// extracted by mini-css-extract-plugin
export default {"dialogHeaderContainer":"SimpleDialog_dialogHeaderContainer__3eH3O","dialogTitle":"SimpleDialog_dialogTitle__5jscz","dialogAction":"SimpleDialog_dialogAction__DS+6z"};